import api from '../../lib/api';
import type { OrgUnitDependencies, OrgUnitNode, OrgUnitPayload } from './types';

export const fetchOrgUnitTree = async (rootId?: string): Promise<OrgUnitNode[]> => {
  const { data } = await api.get<OrgUnitNode[]>('org-units/tree', {
    params: rootId ? { rootId } : undefined,
  });
  return data;
};

export const createOrgUnit = async (payload: OrgUnitPayload): Promise<OrgUnitNode> => {
  const { data } = await api.post<OrgUnitNode>('org-units', payload);
  return data;
};

export const updateOrgUnit = async (
  id: string,
  payload: Partial<OrgUnitPayload & { active: boolean }>,
): Promise<OrgUnitNode> => {
  const { data } = await api.put<OrgUnitNode>(`org-units/${id}`, payload);
  return data;
};

export const reparentOrgUnit = async (
  id: string,
  newParentId: string | null,
): Promise<OrgUnitNode> => {
  const { data } = await api.post<OrgUnitNode>(`org-units/${id}/reparent`, { newParentId });
  return data;
};

export const deleteOrgUnit = async (id: string): Promise<void> => {
  await api.delete(`org-units/${id}`);
};

export const fetchOrgUnitDependencies = async (id: string): Promise<OrgUnitDependencies> => {
  const { data } = await api.get<OrgUnitDependencies>(`org-units/${id}/dependencies`);
  return data;
};
